import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Patients from './Patients';
import Patient from './Patient/Patient';
import PatientAdd from './PatientAdd/PatientAdd';

export const PatientsRoutes = (
  <Route path="patients" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Health']}>
          <Patients />
        </PrivateRoute>
      )}
    />

    <Route
      path=":patientId"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Patient', 'Health']}>
          <Patient />
        </PrivateRoute>
      )}
    />

    <Route
      path="add"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Physician', 'Health']}>
          <PatientAdd />
        </PrivateRoute>
      )}
    />

    <Route
      path=":patientId/edit"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Physician', 'Health']}>
          <PatientAdd edit />
        </PrivateRoute>
      )}
    />
  </Route>
);
